/**
 * Team (Équipe) Types
 * Types for the team calendar feature
 */

export type DayOfWeek = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';

export interface TeamMember {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: 'admin' | 'bureau';
}

export interface DayPlanning {
  start: string;      // HH:MM format
  end: string;        // HH:MM format
  enabled: boolean;
  workLocation?: 'office' | 'remote';
}

export interface TeamMemberPlanning {
  monday: DayPlanning;
  tuesday: DayPlanning;
  wednesday: DayPlanning;
  thursday: DayPlanning;
  friday: DayPlanning;
  saturday: DayPlanning;
  sunday: DayPlanning;
}

export interface TeamAppointment {
  id: string;
  date: string;           // YYYY-MM-DD
  dayOfWeek: string;
  startTime: string;      // HH:MM
  endTime: string;        // HH:MM
  title: string;
  isRecurring?: boolean;
  expandedFromRecurring?: boolean;
  isProfessional?: boolean;  // When true, time counts toward worked hours (e.g., client meeting, training)
}

export interface TeamMemberWithPlanning {
  user: TeamMember;
  planning: TeamMemberPlanning;
  appointments: TeamAppointment[];
}

export interface TeamPlanningApiResponse {
  success: boolean;
  data?: TeamMemberWithPlanning[];
  message?: string;
}

// Helper constants
export const DAYS_OF_WEEK: DayOfWeek[] = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday'
];

export const DAY_LABELS: Record<DayOfWeek, { fr: string; short: string }> = {
  monday: { fr: 'Lundi', short: 'Lun' },
  tuesday: { fr: 'Mardi', short: 'Mar' },
  wednesday: { fr: 'Mercredi', short: 'Mer' },
  thursday: { fr: 'Jeudi', short: 'Jeu' },
  friday: { fr: 'Vendredi', short: 'Ven' },
  saturday: { fr: 'Samedi', short: 'Sam' },
  sunday: { fr: 'Dimanche', short: 'Dim' }
};
